/*********************** Custom JS for Boost AI Search & Discovery  ************************/
(function() {
  'use strict';

  var SEARCH_INPUT_SELECTOR = '.boost-sd__search-widget-init-input, form.search-form input[name="q"]';
  var PLACEHOLDER_TEXT = null;
  var PLACEHOLDER_OBSERVERS = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  var PRODUCT_ITEM_SELECTOR = '.boost-sd__product-item, .boost-sd__search-result-item, .boost-sd__suggestion-queries-item--product, [data-product][data-product-id]';
  var IMAGE_WRAPPER_SELECTORS = [
    '.boost-sd__product-image-wrapper',
    '.boost-sd__product-item-grid-view-layout-image',
    '.boost-sd__product-link-image',
    '.boost-sd__search-result-item-image',
    '.boost-sd__search-result-item-media',
    '.boost-sd__search-result-item-media-wrapper'
  ];
  var THEME_STICKER_ATTRIBUTE = 'data-theme-sticker';
  var htmlDecoder = typeof document !== 'undefined' ? document.createElement('textarea') : null;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function getPlaceholderText() {
    if (PLACEHOLDER_TEXT !== null) {
      return PLACEHOLDER_TEXT;
    }
    var body = document.body;
    var fallback = 'SEARCH';
    if (body && body.dataset && body.dataset.searchPlaceholder) {
      PLACEHOLDER_TEXT = body.dataset.searchPlaceholder;
      return PLACEHOLDER_TEXT;
    }
    PLACEHOLDER_TEXT = fallback;
    return PLACEHOLDER_TEXT;
  }

  function applyPlaceholder(input) {
    if (!input || !input.setAttribute) {
      return;
    }
    var text = getPlaceholderText();
    if (!text) {
      return;
    }
    if (input.getAttribute('placeholder') !== text) {
      input.setAttribute('placeholder', text);
    }
    if (input.getAttribute('aria-label') !== text) {
      input.setAttribute('aria-label', text);
    }
    if (input.hasAttribute('data-placeholder') && input.getAttribute('data-placeholder') !== text) {
      input.setAttribute('data-placeholder', text);
    }
  }

  function bindPlaceholderObserver(input) {
    if (!input || typeof MutationObserver === 'undefined' || (PLACEHOLDER_OBSERVERS && PLACEHOLDER_OBSERVERS.has(input))) {
      return;
    }
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].attributeName === 'placeholder') {
          applyPlaceholder(input);
          return;
        }
      }
    });
    observer.observe(input, { attributes: true, attributeFilter: ['placeholder'] });
    if (PLACEHOLDER_OBSERVERS) {
      PLACEHOLDER_OBSERVERS.set(input, observer);
    }
  }

  function matchesSelector(el, selector) {
    if (!el || el.nodeType !== 1) {
      return false;
    }
    var proto = Element.prototype;
    var matchFn = proto.matches || proto.msMatchesSelector || proto.webkitMatchesSelector;
    if (!matchFn) {
      return false;
    }
    return matchFn.call(el, selector);
  }

  function handleSearchInput(input) {
    if (!input) {
      return;
    }
    applyPlaceholder(input);
    bindPlaceholderObserver(input);
  }

  function scanForSearchInputs(root) {
    if (!root) {
      return;
    }
    if (matchesSelector(root, SEARCH_INPUT_SELECTOR)) {
      handleSearchInput(root);
    }
    if (root.querySelectorAll) {
      var nodes = root.querySelectorAll(SEARCH_INPUT_SELECTOR);
      for (var i = 0; i < nodes.length; i += 1) {
        handleSearchInput(nodes[i]);
      }
    }
  }

  function startSearchInputObserver() {
    if (typeof MutationObserver === 'undefined') {
      return;
    }
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length) {
          for (var j = 0; j < mutation.addedNodes.length; j += 1) {
            var node = mutation.addedNodes[j];
            if (node.nodeType === 1) {
              scanForSearchInputs(node);
            }
          }
        }
      }
    });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  function hasBoostSearchClass(el) {
    if (!el || typeof el.className !== 'string') {
      return false;
    }
    return el.className.indexOf('boost-sd__search') !== -1;
  }

  function clearInlineScrollLock(el) {
    if (!el || !el.style) {
      return;
    }
    if (el.style.overflow) {
      el.style.overflow = '';
    }
    if (el.style.position === 'fixed') {
      el.style.position = '';
    }
    if (el.style.height && el.style.height !== '') {
      el.style.height = '';
    }
    if (el.style.paddingRight && el.style.paddingRight !== '') {
      el.style.paddingRight = '';
    }
  }

  function setScrollUnlockState(isUnlocked) {
    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) {
      return;
    }
    if (isUnlocked) {
      body.setAttribute('data-boost-sd-scroll-unlocked', 'true');
      html.setAttribute('data-boost-sd-scroll-unlocked', 'true');
    } else {
      body.removeAttribute('data-boost-sd-scroll-unlocked');
      html.removeAttribute('data-boost-sd-scroll-unlocked');
    }
  }

  function evaluateScrollLock() {
    var body = document.body;
    var html = document.documentElement;
    if (!body || !html || typeof window.getComputedStyle === 'undefined') {
      return;
    }
    var boostActive = hasBoostSearchClass(body) || hasBoostSearchClass(html);
    if (!boostActive) {
      setScrollUnlockState(false);
      return;
    }
    scanForSearchInputs(document);
    var bodyLocked = window.getComputedStyle(body).overflow === 'hidden';
    var htmlLocked = window.getComputedStyle(html).overflow === 'hidden';
    var shouldUnlock = bodyLocked || htmlLocked;
    if (shouldUnlock) {
      clearInlineScrollLock(body);
      clearInlineScrollLock(html);
      setScrollUnlockState(true);
    } else {
      setScrollUnlockState(false);
    }
  }

  function startScrollObserver() {
    if (typeof MutationObserver === 'undefined') {
      return;
    }
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        if (mutation.type === 'attributes' && (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
          evaluateScrollLock();
          return;
        }
      }
    });
    observer.observe(document.body || document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  function bindGlobalEvents() {
    document.addEventListener('focusin', function(event) {
      var target = event.target;
      if (matchesSelector(target, SEARCH_INPUT_SELECTOR)) {
        handleSearchInput(target);
        evaluateScrollLock();
      }
    });

    document.addEventListener('shopify:section:load', function(event) {
      scanForSearchInputs(event && event.target ? event.target : document);
      evaluateScrollLock();
      scanForProductItems(event && event.target ? event.target : document);
    });
  }

  function getThemeSettings() {
    return (window.PXUTheme && window.PXUTheme.theme_settings) ? window.PXUTheme.theme_settings : {};
  }

  function getThemeTranslations() {
    return (window.PXUTheme && window.PXUTheme.translation) ? window.PXUTheme.translation : {};
  }

  function decodeHtmlEntities(value) {
    if (!value || !htmlDecoder) {
      return value || '';
    }
    htmlDecoder.innerHTML = value;
    return htmlDecoder.value;
  }

  function handleize(value) {
    if (typeof value !== 'string') {
      return '';
    }
    return value.toLowerCase()
      .replace(/[\s_]+/g, '-')
      .replace(/[^a-z0-9\-]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function toArray(value) {
    if (Array.isArray(value)) {
      return value;
    }
    if (typeof value === 'string') {
      var trimmed = value.trim();
      if (!trimmed) {
        return [];
      }
      if (trimmed[0] === '[' || trimmed[0] === '{' || trimmed[0] === '"') {
        try {
          var parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return parsed;
          }
        } catch (err) {
          return [];
        }
      }
      if (trimmed.indexOf(',') !== -1) {
        return trimmed.split(',').map(function(part) {
          return part.trim();
        });
      }
      return [trimmed];
    }
    return [];
  }

  function parseProductData(node) {
    if (!node) {
      return null;
    }
    var raw = node.getAttribute('data-product');
    if (!raw) {
      return null;
    }
    var decoded = decodeHtmlEntities(raw);
    if (!decoded) {
      return null;
    }
    try {
      return JSON.parse(decoded);
    } catch (error) {
      return null;
    }
  }

  function normalizeVariants(product) {
    var variants = product && product.variants ? product.variants : [];
    if (typeof variants === 'string') {
      var trimmed = variants.trim();
      if (trimmed) {
        try {
          variants = JSON.parse(trimmed);
        } catch (error) {
          variants = [];
        }
      }
    }
    return Array.isArray(variants) ? variants : [];
  }

  function buildLabelHandles(product) {
    var handles = [];
    var collections = toArray(product && product.collections ? product.collections : []);
    var tags = toArray(product && product.tags ? product.tags : []);
    if (!collections.length && product && product.productCollections) {
      collections = toArray(product.productCollections);
    }
    if (collections && collections.length) {
      collections.forEach(function(collection) {
        var handle = handleize(collection && collection.handle ? collection.handle : collection);
        if (handle && handles.indexOf(handle) === -1) {
          handles.push(handle);
        }
      });
    }
    if (tags && tags.length) {
      tags.forEach(function(tag) {
        var handle = handleize(tag);
        if (handle && handles.indexOf(handle) === -1) {
          handles.push(handle);
        }
      });
    }
    if (product && product.category) {
      var categoryHandle = handleize(product.category);
      if (categoryHandle && handles.indexOf(categoryHandle) === -1) {
        handles.push(categoryHandle);
      }
    }
    return handles;
  }

  function getStickerText(key, fallback) {
    var translations = getThemeTranslations();
    if (translations && (translations[key] || translations[key + '_sticker'])) {
      return translations[key] || translations[key + '_sticker'];
    }
    return fallback;
  }

  function isStickersEnabled() {
    var settings = getThemeSettings();
    return !!settings.stickers_enabled;
  }

  function hasBoostSoldOutLabel(node) {
    if (!node || !node.querySelector) {
      return false;
    }
    return !!node.querySelector('.boost-sd__product-label--soldout');
  }

  function buildStickerMarkup(product, node) {
    if (!product || !isStickersEnabled()) {
      return '';
    }

    var handles = buildLabelHandles(product);
    var hasHandle = function(value) {
      return handles.indexOf(value) !== -1;
    };

    var variants = normalizeVariants(product);
    var isAvailable = false;
    for (var i = 0; i < variants.length; i += 1) {
      var variantAvailable = variants[i] && variants[i].available;
      if (typeof variantAvailable === 'string') {
        variantAvailable = variantAvailable === 'true';
      }
      if (variantAvailable) {
        isAvailable = true;
        break;
      }
    }

    var stickers = [];
    var newHandles = ['new', 'new-arrivals', 'new-arrival'];
    for (var n = 0; n < newHandles.length; n += 1) {
      if (hasHandle(newHandles[n])) {
        stickers.push('<div class="new-sticker thumbnail-sticker"><span class="sticker-text">' + getStickerText('new_sticker', 'New') + '</span></div>');
        break;
      }
    }

    var mappedCollections = [
      { handle: 'best-seller', className: 'best-seller-sticker', key: 'best_seller', fallback: 'Best Seller' },
      { handle: 'coming-soon', className: 'coming-soon-sticker', key: 'coming_soon', fallback: 'Coming Soon' },
      { handle: 'pre-order', className: 'pre-order-sticker', key: 'pre_order', fallback: 'Pre Order' },
      { handle: 'staff-pick', className: 'staff-pick-sticker', key: 'staff_pick', fallback: 'Staff Pick' },
      { handle: 'online-exclusive', className: 'online-exclusive-sticker', key: 'online_exclusive', fallback: 'Online Exclusive' },
      { handle: 'back-in-stock', className: 'back-in-stock-sticker', key: 'back_in_stock', fallback: 'Back In Stock' },
      { handle: 'almost-gone', className: 'almost-gone-sticker', key: 'almost_gone', fallback: 'Almost Gone' }
    ];

    mappedCollections.forEach(function(map) {
      if (hasHandle(map.handle)) {
        stickers.push('<div class="' + map.className + ' thumbnail-sticker"><span class="sticker-text">' + getStickerText(map.key, map.fallback) + '</span></div>');
      }
    });

    var priceMin = parseFloat(product && product.priceMin ? product.priceMin : 0);
    var compareAtPriceMax = parseFloat(product && product.compareAtPriceMax ? product.compareAtPriceMax : 0);
    if (isAvailable && compareAtPriceMax > priceMin && priceMin > 0) {
      stickers.push('<div class="sale-sticker thumbnail-sticker"><span class="sticker-text">' + getStickerText('sale', 'Sale') + '</span></div>');
    } else if (!isAvailable && !hasBoostSoldOutLabel(node)) {
      stickers.push('<div class="sale-sticker thumbnail-sticker"><span class="sticker-text">' + getStickerText('sold_out', 'Sold Out') + '</span></div>');
    }

    if (!stickers.length) {
      return '';
    }
    var settings = getThemeSettings();
    var shape = settings.sticker_shape || 'square';
    var position = settings.sticker_position || 'left';
    return '<div class="sticker-holder sticker-shape-' + shape + ' sticker-position-' + position + '" ' + THEME_STICKER_ATTRIBUTE + '="true"><div class="sticker-holder__content sticker-holder__content--product">' + stickers.join('') + '</div></div>';
  }

  function applyStickerToNode(node) {
    if (!node || node.nodeType !== 1 || !isStickersEnabled()) {
      return;
    }
    var imageWrapper = findImageWrapper(node);
    if (!imageWrapper) {
      return;
    }
    var product = parseProductData(node);
    if (!product) {
      return;
    }
    var stickerMarkup = buildStickerMarkup(product, node);
    var existing = imageWrapper.querySelector('.sticker-holder[' + THEME_STICKER_ATTRIBUTE + '="true"]');
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
    node.classList.remove('has-thumbnail-sticker');
    imageWrapper.classList.remove('has-thumbnail-sticker');
    if (stickerMarkup) {
      imageWrapper.insertAdjacentHTML('afterbegin', stickerMarkup);
      node.classList.add('has-thumbnail-sticker');
      imageWrapper.classList.add('has-thumbnail-sticker');
    }
  }

  function findImageWrapper(node) {
    if (!node || !node.querySelector) {
      return null;
    }
    for (var i = 0; i < IMAGE_WRAPPER_SELECTORS.length; i += 1) {
      var wrapper = node.querySelector(IMAGE_WRAPPER_SELECTORS[i]);
      if (wrapper) {
        return wrapper;
      }
    }
    var image = node.querySelector('.boost-sd__product-image');
    if (image && image.parentNode) {
      return image.parentNode;
    }
    return null;
  }

  function collectProductNodes(scope) {
    var nodes = [];
    if (!scope) {
      return nodes;
    }
    if (matchesSelector(scope, PRODUCT_ITEM_SELECTOR)) {
      nodes.push(scope);
    }
    if (scope.querySelectorAll) {
      var found = scope.querySelectorAll(PRODUCT_ITEM_SELECTOR);
      if (found && found.length) {
        for (var i = 0; i < found.length; i += 1) {
          nodes.push(found[i]);
        }
      }
    }
    return nodes;
  }

  function scanForProductItems(root) {
    if (!isStickersEnabled()) {
      return;
    }
    var scope = root || document;
    var nodes = collectProductNodes(scope);
    if (!nodes.length && scope === document && document.querySelectorAll) {
      nodes = Array.prototype.slice.call(document.querySelectorAll(PRODUCT_ITEM_SELECTOR));
    }
    if (nodes && nodes.length) {
      for (var i = 0; i < nodes.length; i += 1) {
        applyStickerToNode(nodes[i]);
      }
    }
  }

  function startStickerObserver() {
    if (!isStickersEnabled() || typeof MutationObserver === 'undefined') {
      return;
    }
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length) {
          for (var j = 0; j < mutation.addedNodes.length; j += 1) {
            var node = mutation.addedNodes[j];
            if (node.nodeType !== 1) {
              continue;
            }
            var productNodes = collectProductNodes(node);
            for (var k = 0; k < productNodes.length; k += 1) {
              applyStickerToNode(productNodes[k]);
            }
          }
        }
      }
    });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  onReady(function() {
    scanForSearchInputs(document);
    startSearchInputObserver();
    bindGlobalEvents();
    evaluateScrollLock();
    startScrollObserver();
    scanForProductItems(document);
    startStickerObserver();
  });
})();
